import { listenUser } from "@/pages/api/listenUser";
import { isEqual } from "lodash";
import { useContext } from "react";
import { RootContext } from "../contexts/rootContext";

const useUserUpdate = () => {
  const { state, dispatch } = useContext(RootContext);

  const onUpdate = async () => {
    try {
      const result = await listenUser(state.user.uid, () => {}, true);
      if (result?.userInfo && !isEqual(result.userInfo, state.user)) {
        dispatch({
          type: "user",
          payload: { ...state, user: result.userInfo }
        });
      }
      if (result?.member && !isEqual(result.member, state?.member)) {
        dispatch({
          type: "setMember",
          payload: { ...state, member: result.member }
        });
      }
    } catch {}
  };
  return { onUpdate };
};

export default useUserUpdate;
